module.exports = __webpack_public_path__ + "static/media/fail-font.0018722a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sku/fail-font.png
// module id = 805
// module chunks = 0